
        import * as module0 from '../assets/fonts/AdelleMono_var-Upright.woff2';import * as module1 from '../assets/img/europdf-og.png';import * as module2 from '../assets/img/favicon.svg';import * as module3 from '../assets/img/mo.png';import * as module4 from '../assets/img/no-sales-team.png';import * as module5 from '../assets/img/playground-editor.png';import * as module6 from '../assets/img/playground-examples.png';import * as module7 from '../assets/img/signatures.png';import * as module8 from '../assets/img/stefan.png';import * as module9 from '../assets/svg/EuroPDF-white.svg';import * as module10 from '../assets/svg/EuroPDF.svg'
        const modules = {
            "../assets/fonts/AdelleMono_var-Upright.woff2": module0,
            "../assets/img/europdf-og.png": module1,
            "../assets/img/favicon.svg": module2,
            "../assets/img/mo.png": module3,
            "../assets/img/no-sales-team.png": module4,
            "../assets/img/playground-editor.png": module5,
            "../assets/img/playground-examples.png": module6,
            "../assets/img/signatures.png": module7,
            "../assets/img/stefan.png": module8,
            "../assets/svg/EuroPDF-white.svg": module9,
            "../assets/svg/EuroPDF.svg": module10,
        };
        export default modules;
      